import { api } from '../createApi';
import { TagType } from '../TagType';
import { TAG_CLAUSES } from './documents';

const TAG_BY_LIST = { type: TagType.Clauses, id: 'LIST' };

api.enhanceEndpoints({
  addTagTypes: [TagType.Clauses as TagType],
  endpoints: {
    getClauseSuggestions: {
      providesTags: [TAG_BY_LIST],
    },
    getAllClauses: {
      providesTags: [TAG_BY_LIST],
    },
    updateClauseContent: {
      invalidatesTags: [TAG_BY_LIST],
    },
    deleteDocumentClause: {
      invalidatesTags: [TAG_BY_LIST, TAG_CLAUSES],
    },
  },
});
